import React, { useContext } from "react";

import { css } from "@emotion/react";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../../context";

export const LockedBreakpoint2 = () => {
  const { theme } = useContext(DiscountProgressBarContext);

  const circleClass = css`
    fill: ${theme.breakpoint.inactiveColor};
    stroke: ${theme.breakpoint.inactiveColor};
  `;

  const pathClass = css`
    fill: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.breakpoint.inactiveColorKey
      )
    )};
  `;

  return (
    <span
      className={"ig-dp-locked-breakpoint"}
      css={css`
        display: block;
      `}
    >
      <svg width={28} height={28} fill="none">
        <circle cx={14} cy={14} r={13.5} css={circleClass} />
        <path
          css={pathClass}
          d="M9.125 21c-.311 0-.578-.11-.795-.335a1.12 1.12 0 0 1-.33-.808v-8.266c0-.317.109-.587.33-.808.221-.221.484-.335.795-.335h1.313V8.619c0-1.002.348-1.859 1.038-2.56A3.41 3.41 0 0 1 14 5c.99 0 1.83.35 2.524 1.059.694.705 1.038 1.558 1.038 2.56v1.829h1.313c.311 0 .578.11.795.335.217.225.33.491.33.808v8.266a1.1 1.1 0 0 1-.33.808c-.221.22-.484.335-.795.335h-9.75Zm2.438-10.552h4.874V8.619c0-.686-.236-1.269-.712-1.752A2.328 2.328 0 0 0 14 6.143c-.675 0-1.249.24-1.725.724a2.403 2.403 0 0 0-.713 1.752v1.829Zm-2.438 9.41h9.75V11.59h-9.75v8.267ZM14 17.19c.401 0 .742-.14 1.024-.419a1.37 1.37 0 0 0 .42-1.01c0-.391-.143-.727-.42-1.04A1.327 1.327 0 0 0 14 14.254c-.401 0-.742.156-1.024.469-.281.312-.42.659-.42 1.04 0 .38.143.731.42 1.01.278.277.623.419 1.024.419Z"
        />
      </svg>
    </span>
  );
};
